import { makeVar, ReactiveVar } from '@apollo/client';

export type MapDirectionsTarget = {
  label: string;
  latLng: string;
};

export const mapDirectionsTarget: ReactiveVar<MapDirectionsTarget | null> =
  makeVar<MapDirectionsTarget | null>(null);
